const ThemeList = [
  {
    template: 'Birthday',
    label: 'Birthday',
  },
  {
    template: 'Anniversary',
    label: 'Anniversary',
  },
  {
    template: 'Welcome_to_Bitcoin',
    label: 'Welcome to Bitcoin',
  },
  {
    template: 'Thank_you',
    label: 'Thank you',
  },
  {
    template: 'Congrats',
    label: 'Congrats',
  },
];

export default ThemeList;


// WEBPACK FOOTER //
// ./src/Helpers/ThemeList.js